/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 15:18:43
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 17:47:08
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColumns(that) {
    let arr = [
        {
			label: that.isVideoMaterial ? '视频信息' : '图片信息',
			minWidth: '180',
            type: () => import('./tableCells/materialInfoCell.vue'),
		},
        {
            label: '素材标签',
            maxWidth: '130',
            type: () => import('./tableCells/rdTagGroupCell.vue'),
        },
        {
            renderHeader: (h) =>{
                return h('span', { class: 'flex-row-align-center' }, [
                    '关联商品',
                    h('el-tooltip', { props: { openDelay: 300, content: '在[小程序]商品详情页中展示素材 ' } }, [
                        h('i', { class: 'iconfont icon-a-help-circlebangzhu-mian fz-14', style: { color: '#C8C9CC', fontWeight: 100 } }),
                    ]),
                ]);
            },
            width: '126',
            type: () => import('./tableCells/relatedGoodsCell.vue'),
        },
        {   
            key: 'materialSize',
            label: '素材大小',
            minWidth: '80',
            type: ColumnTypes.TextCell,
        },
        {   
            key: '',
            label: '时长',
            minWidth: '80',
            field: 'videoDuration',
            type: () => import('./tableCells/generalCell.vue'),
        },
        {   
            key: 'addTime',
            label: '创建时间',
            minWidth: '110',
            type: ColumnTypes.TextCell,
            sortable: 'custom',
        },
        {   
            key: '',
            label: '创建人',
            minWidth: '80',
            field: 'username',
            type: () => import('./tableCells/generalCell.vue'),
        },
        {   
            key: '',
            label: '下载次数',
            minWidth: '80',
            field: 'downloadCnt',
            type: () => import('./tableCells/generalCell.vue'),
        },
        {   
            key: '',
            label: '备注',
            maxWidth: '150',
            type: () => import('./tableCells/remarkCell.vue'),
        },
        {
            label: '操作',
            key: 'operation',
            align: 'right',
            type: ColumnTypes.ButtonsCell,
            width: '100',
        }
    ]
    return arr
}

export default getColumns